import { getIn18Text } from 'api';
import { filterTabMap, LIST_MODEL, MAIL_MAILLIST_TAB_AVTIVE_KEY } from '@web-mail/common/constant';
import { api } from 'api';
const storeApi = api.getDataStoreApi();
export const genCustomerState = () => {
    var _a;
    const mailListStateTab = ((_a = storeApi.getSync(MAIL_MAILLIST_TAB_AVTIVE_KEY)) === null || _a === void 0 ? void 0 : _a.data) || 'ALL';
    return {
        listLoading: false,
        customerListLoading: false,
        customerSearchListLoading: false,
        refreshBtnLoading: false,
        mailSearching: '',
        mailSearchStateMap: {},
        mailSearchKey: '',
        selectedSearchKeys: { id: '', accountId: '' },
        selectedSearchContacts: { list: [], accountId: '' },
        searchTreeList: [],
        searchTreeListPageSize: 20,
        searchTreeListPageNum: 1,
        expandedSearchKeys: [],
        searchList: [],
        searchTotal: 20,
        advancedSearchVisible: false,
        advancedSearchLoading: false,
        selectedKeys: { id: '', accountId: '' },
        selectedGroupKeys: { id: '', accountId: '' },
        selectedContacts: { list: [], accountId: '' },
        customerTreeList: [],
        customerGroupTree: [],
        customerTreeIdList: [],
        expandedKeys: [],
        expandedGroupKeys: [],
        expandedKeysNoContacts: {},
        refreshHasNewMail: false,
        mailDataList: [],
        mailTotal: 20,
        scrollTop: 0,
        noticeNum: 0,
        activeIds: [],
        mailListMenuVisible: false,
        mailListStateTab: mailListStateTab,
        searchListStateTab: 'ME',
        mailListTabMenu: 'ALL',
        mailListTabMenuSearch: 'ALL',
        selectedMailId: { id: '', accountId: '' },
        mailListInitIsFailed: false,
        mailListResizeProcessing: false,
        mailTabs: filterTabMap.customer,
        defaultMailListSelectedModel: LIST_MODEL.INIT,
        readMailWindowActiveMailId: null,
        customerTreeListHasMore: true,
        searchTreeListHasMore: true,
        customerAsideDetail: {
            email: '',
            type: '',
        },
        searchValue: '',
        selectedTreeCustomerGroup1Id: 'ALL',
        customerGroupList: [{ name: getIn18Text('QUANBUKEHU'), id: 'ALL', hasChildren: false, count: 0 }],
        customerTreeListPage: 1,
        customerGroupMap: {},
        visitedCustomerMap: {},
        groupCollapseKeys: [],
        searchGroupCollapseKeys: [],
    };
};
